<template>
  <div class="menu-dom">
    <menu-item
      v-for="(item, index) in menuData"
      :key="index"
      :pageType="item.pageType"
      :title="item.title"
      :backgroundType="item.backgroundType"
      :backgroundCode="item.backgroundCode"
      :backgroundPicUrl="item.backgroundPicUrl"
      :v="item.v"
      :backgroundIconUrl="item.backgroundIconUrl"
      :liveJumpUrl="liveJumpUrl"
      :signStatus="signStatus"
      :signflag="signflag"
    >
    </menu-item></div
></template>
<script>
import MenuItem from "./MenuItem.vue";
export default {
  name: "ConfMenu",
  // eslint-disable-next-line vue/no-unused-components
  components: { MenuItem },

  props: {
    menuData: {
      type: Array,
      default: () => []
    },
    liveJumpUrl: {
      type: String,
      default: ""
    },
    signStatus: {
      type: Number,
      default: 0
    },
    signflag: {
      type: Number,
      default: 0
    }
  }
};
</script>
<style scoped>
.menu-dom {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  margin-left: -5px;
  margin-right: -5px;

  box-sizing: border-box;
}
</style>
